import * as XLSX from 'xlsx';
export const loadExcelData = async filePath => {
  try {
    const response = await fetch(filePath);
    const arrayBuffer = await response.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, {
      type: 'array'
    }); // Pega a primeira planilha

    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName]; // Converte para JSON

    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1
    }); // Remove linhas vazias e retorna

    return jsonData.filter(row => row.length > 0 && row.some(cell => cell !== null && cell !== ''));
  } catch (error) {
    console.error('Erro ao carregar planilha:', error);
    return [];
  }
};
export const getFrotaOptions = async () => {
  try {
    const data = await loadExcelData('/cadastros/Veiculos.xls');
    if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

    const headers = data[0]; // Encontra o índice da coluna "Frota"

    const frotaIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('frota'));

    if (frotaIndex === -1) {
      console.warn('Coluna "Frota" não encontrada na planilha');
      return [];
    } // Extrai os valores únicos da coluna Frota (excluindo o cabeçalho)


    const frotaValues = data.slice(1).map(row => row[frotaIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

    const uniqueFrotaValues = [...new Set(frotaValues)].sort();
    return uniqueFrotaValues;
  } catch (error) {
    console.error('Erro ao carregar opções de frota:', error);
    return [];
  }
}; // Cache para os dados da planilha

let frotaDataCache = null;
let placaDataCache = null;
let motoristaDataCache = null;
let gestorDataCache = null;
let modeloDataCache = null;
let lastCacheTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

export const searchFrotaOptions = async (searchTerm, maxResults = 5) => {
  try {
    const now = Date.now(); // Verifica se o cache ainda é válido

    if (!frotaDataCache || now - lastCacheTime > CACHE_DURATION) {
      const data = await loadExcelData('/cadastros/Veiculos.xls');
      if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

      const headers = data[0]; // Encontra o índice da coluna "Frota"

      const frotaIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('frota'));

      if (frotaIndex === -1) {
        console.warn('Coluna "Frota" não encontrada na planilha');
        return [];
      } // Extrai os valores únicos da coluna Frota (excluindo o cabeçalho)


      const frotaValues = data.slice(1).map(row => row[frotaIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

      frotaDataCache = [...new Set(frotaValues)].sort();
      lastCacheTime = now;
    } // Filtra os resultados baseado no termo de busca


    const filteredResults = frotaDataCache.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase())); // Retorna apenas os primeiros maxResults resultados

    return filteredResults.slice(0, maxResults);
  } catch (error) {
    console.error('Erro ao buscar opções de frota:', error);
    return [];
  }
};
export const searchPlacaOptions = async (searchTerm, maxResults = 5) => {
  try {
    const now = Date.now(); // Verifica se o cache ainda é válido

    if (!placaDataCache || now - lastCacheTime > CACHE_DURATION) {
      const data = await loadExcelData('/cadastros/Veiculos.xls');
      if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

      const headers = data[0]; // Encontra o índice da coluna "Placa"

      const placaIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('placa'));

      if (placaIndex === -1) {
        console.warn('Coluna "Placa" não encontrada na planilha');
        return [];
      } // Extrai os valores únicos da coluna Placa (excluindo o cabeçalho)


      const placaValues = data.slice(1).map(row => row[placaIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

      placaDataCache = [...new Set(placaValues)].sort();
      lastCacheTime = now;
    } // Filtra os resultados baseado no termo de busca


    const filteredResults = placaDataCache.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase())); // Retorna apenas os primeiros maxResults resultados

    return filteredResults.slice(0, maxResults);
  } catch (error) {
    console.error('Erro ao buscar opções de placa:', error);
    return [];
  }
};
export const searchMotoristaOptions = async (searchTerm, maxResults = 5) => {
  try {
    const now = Date.now(); // Verifica se o cache ainda é válido

    if (!motoristaDataCache || now - lastCacheTime > CACHE_DURATION) {
      const data = await loadExcelData('/cadastros/Motoristas.xls');
      if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

      const headers = data[0]; // Encontra o índice da coluna "Nome"

      const nomeIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('nome'));

      if (nomeIndex === -1) {
        console.warn('Coluna "Nome" não encontrada na planilha');
        return [];
      } // Extrai os valores únicos da coluna Nome (excluindo o cabeçalho)


      const nomeValues = data.slice(1).map(row => row[nomeIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

      motoristaDataCache = [...new Set(nomeValues)].sort();
      lastCacheTime = now;
    } // Filtra os resultados baseado no termo de busca


    const filteredResults = motoristaDataCache.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase())); // Retorna apenas os primeiros maxResults resultados

    return filteredResults.slice(0, maxResults);
  } catch (error) {
    console.error('Erro ao buscar opções de motorista:', error);
    return [];
  }
};
export const searchGestorOptions = async (searchTerm, maxResults = 5) => {
  try {
    const now = Date.now(); // Verifica se o cache ainda é válido

    if (!gestorDataCache || now - lastCacheTime > CACHE_DURATION) {
      // Tenta primeiro na planilha Motoristas (pode ter uma coluna Gestor)
      let data = await loadExcelData('/cadastros/Motoristas.xls');

      if (data.length === 0) {
        // Se não encontrar, tenta na planilha Veiculos
        data = await loadExcelData('/cadastros/Veiculos.xls');
      }

      if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

      const headers = data[0]; // Encontra o índice da coluna "Gestor" ou similar

      const gestorIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('gestor'));

      if (gestorIndex === -1) {
        // Se não encontrar "Gestor", tenta "Nome" como fallback
        const nomeIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('nome'));

        if (nomeIndex === -1) {
          console.warn('Coluna "Gestor" ou "Nome" não encontrada nas planilhas');
          return [];
        } // Extrai os valores únicos da coluna Nome (excluindo o cabeçalho)


        const nomeValues = data.slice(1).map(row => row[nomeIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

        gestorDataCache = [...new Set(nomeValues)].sort();
        lastCacheTime = now;
      } else {
        // Extrai os valores únicos da coluna Gestor (excluindo o cabeçalho)
        const gestorValues = data.slice(1).map(row => row[gestorIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

        gestorDataCache = [...new Set(gestorValues)].sort();
        lastCacheTime = now;
      }
    } // Filtra os resultados baseado no termo de busca


    const filteredResults = gestorDataCache.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase())); // Retorna apenas os primeiros maxResults resultados

    return filteredResults.slice(0, maxResults);
  } catch (error) {
    console.error('Erro ao buscar opções de gestor:', error);
    return [];
  }
};
export const searchModeloOptions = async (searchTerm, maxResults = 10) => {
  try {
    const now = Date.now(); // Verifica se o cache ainda é válido

    if (!modeloDataCache || now - lastCacheTime > CACHE_DURATION) {
      const data = await loadExcelData('/cadastros/Modelos.xlsx');
      if (data.length === 0) return []; // Pega o cabeçalho (primeira linha)

      const headers = data[0]; // Encontra o índice da coluna "Modelos"

      const modeloIndex = headers.findIndex(header => header && header.toString().toLowerCase().includes('modelo'));

      if (modeloIndex === -1) {
        console.warn('Coluna "Modelos" não encontrada na planilha');
        return [];
      } // Extrai os valores únicos da coluna Modelos (excluindo o cabeçalho)


      const modeloValues = data.slice(1).map(row => row[modeloIndex]).filter(value => value && value.toString().trim() !== '').map(value => value.toString().trim()); // Remove duplicatas e ordena

      modeloDataCache = [...new Set(modeloValues)].sort();
      lastCacheTime = now;
    } // Filtra os resultados baseado no termo de busca


    const filteredResults = modeloDataCache.filter(option => option.toLowerCase().includes(searchTerm.toLowerCase())); // Retorna apenas os primeiros maxResults resultados

    return filteredResults.slice(0, maxResults);
  } catch (error) {
    console.error('Erro ao buscar opções de modelo:', error);
    return [];
  }
};